import { gql } from '@apollo/client';
import { AccountAssetFragment } from '../fragments/AccountAssetFragment';
/**
 * @const AccountAssetsQuery
 * @since 1.0.0
 */
export const AccountAssetsQuery = gql `
  query AccountAssetsQuery($input: AccountAssetsInput!) {
    accountAssets(input: $input) {
      ...AccountAssetFragment
    }
  }

  ${AccountAssetFragment}
`;
